import { FeatureToggles } from '@spartacus/core'

export const ebFeatureToggles: FeatureToggles = {}
